import { render } from "./documents_workflow.html?vue&type=template&id=095d1b6d&external"
import script from "./documents_workflow.js?vue&type=script&lang=js&external"
export * from "./documents_workflow.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__